import React from "react";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Box from "@mui/material/Box";
import { ProductToolTipData } from "../types";

interface ProductListProps {
  title: string;
  items: string[];
}

const ProductList: React.FC<ProductListProps> = ({ title, items }) => {
  if (!items?.length) return null;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="subtitle2"
        sx={{
          color: "#424242",
          mb: 0.5,
          fontWeight: 500,
        }}
      >
        {title}
      </Typography>
      <List dense disablePadding>
        {items.map((item, index) => (
          <ListItem
            key={index}
            sx={{
              py: 0.5,
              px: 1,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontSize: "12px",
                color: "#666",
              }}
            >
              {item}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export const ProductsTooltipContent: React.FC<{ data: ProductToolTipData }> = ({
  data,
}) => {
  const { includedProducts, excludedProducts } = data;

  return (
    <Box sx={{ p: 1, maxWidth: 300, minWidth: 200 }}>
      <ProductList
        title="Included Products"
        items={includedProducts.map((item) => item.name ?? "Unnamed Product")}
      />
      {excludedProducts.length > 0 && (
        <ProductList
          title="Excluded Products"
          items={excludedProducts.map((item) => item.name ?? "Unnamed Product")}
        />
      )}
    </Box>
  );
};
